import { useEffect, useState } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as GoogleLogo } from '../../../assets/img/google.svg';
import PhoneInput from 'react-phone-input-2';
import MyInput from '../../../components/ui/MyInput';
import { translate } from '../../../utils/language';
import PrimaryButton from '../../../components/ui/PrimaryButton';


const Register = ({ setActiveSurveys }) => {
    const [termsChecked, setTermsChecked] = useState(false);
    const [isError, setIsError] = useState([]);
    const [phone, setPhone] = useState("")
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const navigate = useNavigate()

    const errorGenerator = newError => {
        setIsError(state => {
            const newState = [...state];
            newState.push(newError);
            return newState;
        });
        return true;
    };

    const errorChecker = conditions => {
        setIsError([]);
        const failedCondition = conditions.filter(condition => {
            const check = condition.check;
            if (check) return errorGenerator(condition.error);
        });
        if (failedCondition.length > 0) return true;
    };

    const createConditionsStep2 = [
        {
            check: !name,
            error: 'missingName',
        },
        {
            check: !surname,
            error: 'missingSurname',
        },
        {
            check: !/^905\d{2}[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/.test(phone),
            error: 'missingPhone',
        },
    ]

    const sendRegisterSurvey = async () => {

        const isErrorChecker = errorChecker(createConditionsStep2);
        if (isErrorChecker) return;
        try {
            const registerResponse = await CreateAction({
                method: 'patch',
                path: '/profile',
                data: { name, surname, phone },
                showPreLoader: true,
                isFileUploading: false,
            });

            if (registerResponse?.error) return;
            setActiveSurveys(state => {
                const newState = [...state]
                newState.shift()
                return newState
            })

        } catch (error) {
            ;
        }
    };




    return (
        <div className="authPage d-flex overflow-auto w-full h-full">
            <div className="login bg-[#ffffff] h-[100vh] overflow:hidden flex justify-center">
                <div className="relative flex flex-row flex-wrap items-center justify-center h-[100%]">
                    <img src={process.env.REACT_APP_LOGO} className='w-[261px] fixed left-[55px] top-[55px]' ></img>

                    <div className="z-[1000] w-[300px] sm:w-[500px] bg-[#FFFFFF] rounded-xl">
                        <form className="flex flex-col justify-center  items-center gap-3 h-max" onSubmit={(e) => {
                            e.preventDefault()

                            sendRegisterSurvey()
                        }}

                        >
                            <h2 style={{ marginBottom: '10px', fontSize: "22px", fontWeight: 600 }} className='text-gray-600'>Profil Bilgilerin</h2>
                            <div className="flex sm:flex-row gap-4 w-[300px] sm:w-[500px] flex-col">
                                <MyInput

                                    isError={isError.includes('missingName')}
                                    isDefaultError={isError.includes('missingName')}
                                    isDefaultErrorMessage={
                                        translate('missingName')
                                    }

                                    isRequired
                                    key="name-input"
                                    type="text"
                                    color="black"
                                    classes="h-14"
                                    onChange={(e: any) => setName(e)}
                                    placeholder="İsminiz"
                                    value={name}
                                ></MyInput>
                                <MyInput
                                    isError={isError.includes('missingSurname')}
                                    isDefaultError={isError.includes('missingSurname')}
                                    isDefaultErrorMessage={
                                        translate('missingSurname')
                                    }
                                    isRequired
                                    key="surname-input"
                                    type="text"
                                    color="black"
                                    classes="h-14"
                                    onChange={(e) => setSurname(e)}
                                    placeholder="Soyisminiz"
                                    value={surname}
                                ></MyInput>
                            </div>
                            <div className=" w-[300px] sm:w-[500px]">
                                <PhoneInput
                                    preferredCountries={['tr', 'de']}
                                    inputStyle={{
                                        width: '100%',
                                        borderWidth: '1px',
                                        borderColor: isError.includes("missingPhone") ? '#f56565' : '#D4DBE3',
                                        height: '3.5rem',
                                        borderRadius: '0.5rem',
                                        paddingLeft: '3.5rem',
                                    }}
                                    inputClass="border-red-500"
                                    buttonStyle={{ width: '45px', background: 'white', borderColor: isError.includes("missingPhone") ? '#f56565' : '#D4DBE3', }}
                                    buttonClass=""
                                    searchClass=""
                                    dropdownClass=""
                                    country={'tr'}
                                    value={phone}
                                    onChange={phone => setPhone(phone)}
                                />
                                {
                                    isError.includes("missingPhone") &&
                                    <div className="flex items-start mt-1">
                                        <span className="text-red-500 text-[10pt]">Lütfen geçerli bir telefon numarası giriniz!</span>
                                    </div>


                                }
                            </div>
                            <PrimaryButton
                                isSubmitButton={true}
                                classes={'signup py-4 my-2 rounded h-12 bg-[#6F66F6] transition duration-150 w-full'}
                                value={'Kaydet'}
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>

    )
};

export default Register;
